import "../scss/white_label.scss";
import $ from "jquery"

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

$('#contactWhiteLabel input[type=submit]').on('click', function(){
    $('._form_7 ._field-wrapper').on('DOMSubtreeModified', function(){
        if($('._form_7 ._error-inner').length){
            $('.wpcf7-form-control-wrap[data-name=email]').addClass('wpcf7-not-valid-group');
        }
    });
});

$('.js-form-control').on('input', function(){
    const valInput = $(this).val();

    $('._form_7 form._form ._form-content *[name="email"]').val(valInput);

    if(validateEmail(valInput)){
        $('.wpcf7-form-control-wrap[data-name=email]').removeClass('wpcf7-not-valid-group');
    }
});

$('.js-custom-acceptance input[type=checkbox]').on('change', function(){
    if($(this).is(':checked')){
        $('.js-custom-acceptance').removeClass('invalid-custom-acceptance');
    }else{
        $('.js-custom-acceptance').addClass('invalid-custom-acceptance');
    }
});

$('#contactWhiteLabel').on('submit', function(e){
    e.preventDefault();
    const valInput = $('.js-form-control').val();
    const acceptanceInput = $('.js-custom-acceptance input[type=checkbox]').is(':checked');

    if(!validateEmail(valInput)){
        $('.wpcf7-form-control-wrap[data-name=email]').addClass('wpcf7-not-valid-group');
    }

    if(acceptanceInput){
        $('.js-custom-acceptance').removeClass('invalid-custom-acceptance');

        $('._form_7 form._form ._form-content *[name="email"]').val(valInput);

        $('._form_7 form._form ._submit').trigger("click");

        $('._form_7 form._form ._form-thank-you').on('DOMSubtreeModified', function(){
            // redirect to thank you page
            window.location.href = "/white-label-contact-form-thank-you";
        });
    }else{
        $('.js-custom-acceptance').addClass('invalid-custom-acceptance');
    }
});

$('.js-form-submit-dummy').on('click', function(){
    const valInput = $('.js-form-control').val();

    if( $('.js-form-control').val() && $('.js-custom-acceptance input[type=checkbox]').is(':checked') && validateEmail(valInput)){
        $('#contactWhiteLabel input[type=submit]').trigger('click');
    }

    if(validateEmail(valInput)){
        $('.wpcf7-form-control-wrap[data-name=email]').removeClass('wpcf7-not-valid-group');
    }else{
        $('.wpcf7-form-control-wrap[data-name=email]').addClass('wpcf7-not-valid-group');
    }

    if( $('.js-form-control').val() ){
        $('.wpcf7-form-control-wrap[data-name=email]').removeClass('wpcf7-not-valid-group');
    }else{
        $('.wpcf7-form-control-wrap[data-name=email]').addClass('wpcf7-not-valid-group');
    }

    if( $('.js-custom-acceptance input[type=checkbox]').is(':checked') ){
        $('.js-custom-acceptance').removeClass('invalid-custom-acceptance');
    }else{
        $('.js-custom-acceptance').addClass('invalid-custom-acceptance');
    }
});